<template>
  <div>
    <lk-table :columns='columns' :data='row.purchaseMedicineInfoVoList' class="mytable"/>
  </div>
</template>
<script>

export default {
  props: {
    row: Object,
    goodsType: {
      type: Number,
    },
  },
  mounted() {
    // console.log(this.row);
  },
  computed: {
    columns() {
      const resColumns = [
        {
          title: '行号',
          width: 56,
          render: (h, { index }) => h('span', index + 1),
        },
        {
          title: '商品编码',
          minWidth: 82,
          key: 'purchaseMedicineDrugSerialCode',
        },
        {
          title: '通用名称',
          minWidth: 142,
          key: 'medicineInfoVoApprovedDrugNames',
        },
        {
          title: '批准文号',
          minWidth: 116,
          key: 'medicineInfoVoApprovalCode',
        },
        {
          title: '规格',
          minWidth: 130,
          key: 'medicineInfoVoSpecifications',
        },
        {
          title: '商品名称',
          minWidth: 142,
          key: 'medicineInfoVoGoodsName',
        },
        {
          title: '剂型',
          key: 'medicineInfoVoDosageFormString',
          minWidth: 116,
        },
        {
          title: '单位',
          key: 'purchaseMedicineDrugMinimumPackagingUnit',
          minWidth: 62,
        },
        {
          title: '产地',
          key: 'purchaseMedicineCountryOfOrigin',
          minWidth: 142,
        },
        {
          title: '生产企业',
          key: 'medicineInfoVoManufacturer',
          minWidth: 142,
        },
        {
          title: '计划数量',
          key: 'purchaseMedicineNum',
          minWidth: 82,
        },
        {
          title: '计划单价',
          key: 'purchaseMedicinePlanPrice',
          minWidth: 82,
        },
      ];
      if (this.goodsType === 2) {
        resColumns.splice(3, 1, {
          title: '注册证号/备案号',
          minWidth: 124,
          key: 'medicineInfoVoApprovalCode',
        });
      } else {
        resColumns.splice(3, 1, {
          title: '批准文号',
          minWidth: 116,
          key: 'medicineInfoVoApprovalCode',
        });
      }
      return resColumns;
    },
  },

};
</script>
